import React from 'react'
import './Blog.scss'
import { BlogRecoverySnapshot } from 'Models'

interface BlogRecoveryBannerProps {
  snapshot: BlogRecoverySnapshot
  /** Server version of the article that is currently loaded (null for a new article). */
  serverVersion: number | null
  onRestore: () => void
  /** Hide the prompt but keep the local copy. */
  onNotNow: () => void
  /** Delete the local copy. */
  onDiscard: () => void
}

/** Offers unsaved local work back to the admin. Never applied automatically. */
const BlogRecoveryBanner: React.FC<BlogRecoveryBannerProps> = ({
  snapshot,
  serverVersion,
  onRestore,
  onNotNow,
  onDiscard,
}) => {
  const savedAt = new Date(snapshot.updatedAt).toLocaleString()
  const serverMovedOn =
    serverVersion !== null && snapshot.baseVersion !== null && serverVersion > snapshot.baseVersion

  return (
    <div className='alert alert-warning BlogRecoveryBanner' role='alert'>
      <div className='BlogRecoveryBanner__text'>
        <strong>Unsaved changes found.</strong> A local copy from {savedAt} wasn&apos;t saved to the
        server.
        {serverMovedOn && (
          <>
            {' '}
            This article has been updated since that copy was made, so restoring it will overwrite
            those newer changes the next time you save.
          </>
        )}
      </div>
      <div className='BlogRecoveryBanner__actions'>
        <button type='button' className='Blog__action-bar__btn' onClick={onRestore}>
          Restore
        </button>
        {/* <button type='button' className='Blog__action-bar__btn' onClick={onNotNow}>
          Not now
        </button> */}
        <button type='button' className='Blog__action-bar__btn' onClick={onDiscard}>
          Discard
        </button>
      </div>
    </div>
  )
}

export default BlogRecoveryBanner
